module.exports = __webpack_public_path__ + "img/littl_girls3.19217f34.jpg";